import React, { Component } from 'react';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Raven from 'raven-js';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import Button from '@material-ui/core/Button';
import Ionicon from 'react-ionicons';
import { numberWithCommas } from '../../utils';
import api from '../../api';
import styles from './styles';

import LoginBlock from '../../components/LoginBlock';

// Actions

/**
 *  Main Home Screen
 */
class Home extends Component {
  state = {
    totalMealCount: 0,
    mealCount: 0,
    content: '',
    impact: [],
    totalImpact: []
  };

  componentDidMount() {
    const { loggedIn } = this.props;
    if (loggedIn) {
      this._getMyImpact();
      this._getTotalImpact();
      this._getHomeContent();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { user, loggedIn } = this.props;
    if (!prevProps.loggedIn && loggedIn) {
      this._getMyImpact();
      this._getTotalImpact();
      this._getHomeContent();
    }
  }

  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, { extra: errorInfo });
  }

  _getHomeContent = () => {
    api
      .getHomeMessageContent()
      .then(content => {
        this.setState({ content });
      })
      .catch(err => {
        console.log(err);
      });
  };

  _getMyImpact = () => {
    api
      .getMyImpact()
      .then(result => {
        // this.setState({ mealCount: result.meal_count });
        this.setState({ impact: result });
      })
      .catch(err => {
        console.log(err);
      });
  };

  _getTotalImpact = () => {
    api
      .getAllImpact()
      .then(result => {
        console.log(result);
        console.log('GOOOOO');
        // this.setState({ totalMealCount: result });
        this.setState({ totalImpact: result });
      })
      .catch(err => {
        console.log(err);
      });
  };

  _handleRefresh = () => {};

  _renderMyImpact = () => {
    const { loggedIn, classes } = this.props;
    const { mealCount, impact } = this.state;

    return (
      <div className={classes.impactCircle}>
        <img
          className={classes.logoImage}
          src={require('../../images/logo.png')}
        />
        <span className={classes.mealCountText}>
          {numberWithCommas(impact[3])} Meals
        </span>
        <span className={classes.countingText}>& Counting</span>
      </div>
    );
  };

  _renderTotalImpact = () => {
    const { classes } = this.props;
    const { totalMealCount, totalImpact } = this.state;

    return (
      <div className={classes.impactCircle}>
        <img
          className={classes.logoImage}
          src={require('../../images/logo.png')}
        />
        <span className={classes.mealCountText}>
          {numberWithCommas(totalImpact[0])} Meals
        </span>
        <span className={classes.countingText}>& Counting</span>
      </div>
    );
  };

  render() {
    const { classes, loggedIn } = this.props;
    const { content } = this.state;

    if (!loggedIn) {
      return <LoginBlock />;
    }

    return (
      <Grid container className={classes.root} spacing={0}>
        <Grid item xs={12}>
          <h1 className={classes.title}>Grow</h1>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Paper className={classes.paper}>
            <h3 className={classes.subtitle}>Total Impact</h3>
            {this._renderTotalImpact()}
          </Paper>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Paper className={classes.paper}>
            <h3 className={classes.subtitle}>My Impact</h3>
            {this._renderMyImpact()}
          </Paper>
        </Grid>

        {/* Message Container */}
        <Grid item xs={12} className={classes.messageContainer}>
          <Paper className={classes.paper}>
            <div
              className={classes.homeContent}
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </Paper>
        </Grid>
      </Grid>
    );
  }
}

Home = withStyles(styles)(Home);

const mapStateToProps = state => ({
  token: state.user.token,
  loggedIn: state.user.loggedIn
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: url => push(url)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/home/index.js